import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import includes from 'lodash/collection/includes';
import {
  getSearchGroup,
  getTradableSearchGroup,
} from 'state/exchange/selectors';

import * as KeyCodes from 'constants/KeyCodes';

import { bindActionCreators } from 'redux';
import * as SuggestActions from 'actions/suggest';

if (process.env.NODE_ENV !== 'test') {
  require('./Suggest.scss');
}

class Suggest extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    onClear: PropTypes.func,
    group: PropTypes.string,
  };

  state = {
    value: this.props.defaultValue || '',
  };

  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    const actions = bindActionCreators(SuggestActions, dispatch);
    this.actions = actions;

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.anchorId === nextProps.id) {
      return true;
    } else if (nextState.value !== this.state.value) {
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate() {
    const { selectedIndex } = this.props;
    if (selectedIndex > -1) {
      this.handleSelectItem();
    }
  }

  handleKeyDown(event) {
    const { keyCode } = event;

    const keyCodesToOverride = [
      KeyCodes.ARROW_DOWN,
      KeyCodes.ARROW_UP,
      KeyCodes.ENTER,
      // KeyCodes.TAB, Allow tab to next element
    ];

    if (includes(keyCodesToOverride, keyCode)) {
      event.preventDefault();
    }

    switch (keyCode) {
      case KeyCodes.ARROW_DOWN:
        this.actions.incrementIndicatorIndex();
        break;
      case KeyCodes.ARROW_UP:
        this.actions.decrementIndicatorIndex();
        break;
      case KeyCodes.ESC:
        this.actions.closeAndReset();
        break;
      case KeyCodes.ENTER:
        this.actions.setSelectedIndex(this.props.indicatorIndex);
        break;
      case KeyCodes.TAB:
        // On exact match + TAB pressed, we set the instrument as selected
        const { data } = this.props;
        if (
          Array.isArray(data) &&
          data[0] &&
          data[0].ITEM.toLowerCase() === this.refs.query.value.toLowerCase()
        ) {
          this.actions.setSelectedIndex(0);
        }
        break;
      default:
        return;
    }
  }

  handleSelectItem() {
    const selectedItem = this.props.data[this.props.selectedIndex];
    this.setState({ value: selectedItem.ITEM });
    this.props.onSelect(selectedItem, this.refs.query);
    this.actions.closeAndReset();
  }

  handleBlur() {
    this.actions.closeAndReset();
  }

  handleFocus(event) {
    this.handleChange(event);
  }

  handleOutOfBounds() {
    if (
      this.props.indicatorIndex < 0 ||
      this.props.indicatorIndex >= this.props.data.length - 1
    ) {
      this.actions.setIndicatorIndex(0);
    }
  }

  handleChange(event) {
    this.handleOutOfBounds();
    const query = event.target.value;
    this.setState({ value: query });
    clearTimeout(this.timeout);

    if (query.length === 0 && this.props.onClear) {
      // When user clears input, we want to tell parent to clear selection
      this.props.onClear(this.refs.query);
      this.actions.closeAndReset();

      return;
    } else if (query.length <= 2) {
      this.actions.closeAndReset();
      return;
    }

    this.timeout = setTimeout(() => {
      this.actions.fetchData(
        this.props.group || this.props.searchGroup || 'SEARCH',
        query,
        this.props.id,
      );
    }, 300);
  }

  render() {
    const { id, placeholder, disabled = false, innerRef } = this.props;

    return (
      <div className="Suggest">
        <input
          ref={innerRef}
          id={id}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
          onKeyDown={this.handleKeyDown}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          type="search"
          value={this.state.value}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...state.suggest,

  searchGroup: props.tradable
    ? getTradableSearchGroup(state)
    : getSearchGroup(state),
});
export { Suggest };
export default connect(mapStateToProps)(Suggest);
